import { css } from '@emotion/react'

import colors from './colors'

type Direction = 'top' | 'right' | 'bottom' | 'left'

const floatingBorder = (
  direction: Direction,
  color: string = colors.borderColor,
  borderWidth = 1
) => css`
  display: block;
  position: absolute;
  content: '';
  background-color: ${color};
  ${directionStyle[direction](borderWidth)};
`

const directionStyle = {
  top: (width) => `top:0; left:0; height: ${width}px; width: 100%`,
  right: (width) => `top:0; right:0; height: 100%; width: ${width}px`,
  bottom: (width) => `bottom:0; left:0; height: ${width}px; width: 100%`,
  left: (width) => `top:0; left:0; height: 100%; width: ${width}px`,
}

export default floatingBorder
